import { BinocularsIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Binocular = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <BinocularsIcon size={Sizes[size]} {...rest} color={fill} />;
};

Binocular.displayName = 'Binocular';
